// agents/guru.js
export function handleGuruMessage() {
    window.logToConsole("🧘‍♂️ Checking current gas prices...");
    const message = "GURU SAYS: Gas prices are looking good today! Consider making your transactions now.";
    window.logToConsole(`🧘‍♂️ ${message}`);
}
